import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createReducer } from '@reduxjs/toolkit';
import { closeInfoCard, openInfoCard, setCurrentInfoBanner, setPopupStep } from "./actions";
import { POPUP_TYPES } from "../blocks/infoCards/constants";
var initialState = {
  current: null,
  isOpen: false,
  type: '',
  popupStep: POPUP_TYPES.supportInfoList
};
export var infoCardsReducer = createReducer(initialState, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, closeInfoCard.type, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isOpen: false,
    popupStep: POPUP_TYPES.supportInfoList,
    type: ''
  });
}), openInfoCard.type, function (state, _ref) {
  var newType = _ref.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    isOpen: true,
    type: newType
  });
}), setCurrentInfoBanner.type, function (state, _ref2) {
  var payload = _ref2.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    current: payload
  });
}), setPopupStep.type, function (state, _ref3) {
  var payload = _ref3.payload;
  return _objectSpread(_objectSpread({}, state), {}, {
    popupStep: payload
  });
}));